import React from 'react';
import './AppScreenshotsModal.css';

function AppScreenshotsModal(props) {
  if (!props.showModal)
    return null;

  function handlePrevClick(e) {
    e.stopPropagation();
    props.onPrevClick();
  }

  function handleNextClick(e) {
    e.stopPropagation();
    props.onNextClick();
  }

  const screenshot = props.screenshots[props.modalIndex];

  return (
    <div className="AppScreenshotsModal" onClick={props.onCloseClick}>
      <button onClick={handlePrevClick} className={(props.modalIndex === 0) ? 'disabled' : null}>
        <i className="fa fa-chevron-left fa-lg fa-fw"/>
      </button>
      <div className="Spinner">
        <button>
          <i className="fa fa-circle-o-notch fa-spin fa-lg fa-fw"/>
        </button>
      </div>
      <img src={process.env.PUBLIC_URL + '/assets/' + props.slug + '/full/' + screenshot.src + '.png'}
           alt={screenshot.alt}
           title={screenshot.alt}/>
      <button onClick={handleNextClick} className={(props.modalIndex === props.screenshots.length - 1) ? 'disabled' : null}>
        <i className="fa fa-chevron-right fa-lg fa-fw"/>
      </button>
    </div>
  );
}

export default AppScreenshotsModal;



// WEBPACK FOOTER //
// ./src/components/AppScreenshotsModal/AppScreenshotsModal.js